var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgGameMaintain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_75_12028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 292",
    d: "M8 122.009L36.5385 40.3721H82.4038L114 122.009H8Z",
    fill: "url(#paint0_linear_75_12028)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.64,
    d: "M33.3366 28.2225C33.2524 16.5003 45.0047 6.94726 59.5371 6.86383C74.0696 6.7804 85.9483 16.2082 85.9904 27.8888L33.3366 28.2225Z",
    fill: "#EABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.2888 27.8894C44.2466 19.8381 51.576 13.247 60.7167 13.2053C69.8574 13.1636 77.271 19.6296 77.3132 27.7225L44.2888 27.8894Z",
    fill: "url(#paint1_linear_75_12028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.3364 28.2224L19.141 33.6455L99.975 33.1866L86.285 27.8887L33.3364 28.2224Z",
    fill: "#2F025B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M103.184 33.1716L16.7967 33.7009C15.806 33.707 15.0079 34.515 15.014 35.5057C15.0202 36.4964 15.8283 37.2946 16.8189 37.2885L103.206 36.7592C104.197 36.7531 104.995 35.9451 104.989 34.9544C104.983 33.9637 104.175 33.1655 103.184 33.1716Z",
    fill: "#5D5189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.2245 44.4499C42.2245 44.4499 24.7014 40.7789 20.2363 37.233L46.4368 37.0662L99.4696 36.7324C99.4696 36.7324 88.1386 44.3665 77.5657 44.2413C77.5657 44.2413 77.4393 47.8289 73.3113 47.8289C69.1832 47.8706 46.7738 47.9958 46.7738 47.9958C46.7738 47.9958 41.6769 47.1615 41.6769 44.3248",
    fill: "#2F025B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.3,
    d: "M61.8115 13.1631C61.8115 13.1631 70.9943 18.7531 67.4139 27.722L75.7963 27.6803C75.7963 27.6803 75.4172 15.6661 61.8115 13.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.3,
    d: "M47.3635 24.4686C47.3214 24.3017 47.2793 24.1348 47.2793 23.968C47.1108 20.9644 50.944 16.2088 54.0611 15.9585C55.2827 15.875 56.757 17.0014 56.0409 18.2946C55.1142 20.0049 53.9347 21.5484 52.7132 23.0502C51.8286 24.1765 50.6913 26.1372 48.9642 25.7618C48.206 25.6366 47.6163 25.1777 47.3635 24.4686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.3,
    d: "M59.579 24.1344C59.579 25.3024 58.6523 26.2619 57.4307 26.2619C56.2513 26.2619 55.2825 25.3441 55.2825 24.1344C55.2825 22.9663 56.2092 22.0068 57.4307 22.0068C58.6102 22.0486 59.579 22.9663 59.579 24.1344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.5041 34.6629L17.0244 34.7147C16.6558 34.7169 16.3588 35.0176 16.3611 35.3862C16.3634 35.7548 16.6641 36.0518 17.0327 36.0496L25.5124 35.9978C25.8811 35.9956 26.178 35.6949 26.1757 35.3263C26.1734 34.9577 25.8728 34.6607 25.5041 34.6629Z",
    fill: "url(#paint2_linear_75_12028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M40.3315 34.663L31.8518 34.7147C31.4832 34.7169 31.1862 35.0176 31.1885 35.3862C31.1908 35.7548 31.4915 36.0518 31.8601 36.0496L40.3398 35.9979C40.7084 35.9957 41.0054 35.695 41.0031 35.3264C41.0008 34.9578 40.7001 34.6608 40.3315 34.663Z",
    fill: "url(#paint3_linear_75_12028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M55.2009 34.663L46.7212 34.7147C46.3525 34.7169 46.0556 35.0176 46.0579 35.3862C46.0601 35.7548 46.3608 36.0518 46.7295 36.0496L55.2092 35.9979C55.5778 35.9957 55.8748 35.695 55.8725 35.3264C55.8702 34.9578 55.5695 34.6608 55.2009 34.663Z",
    fill: "url(#paint4_linear_75_12028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M70.0289 34.705L61.5492 34.7567C61.1805 34.7589 60.8836 35.0596 60.8859 35.4282C60.8882 35.7968 61.1888 36.0938 61.5575 36.0916L70.0372 36.0399C70.4058 36.0376 70.7028 35.737 70.7005 35.3684C70.6982 34.9997 70.3975 34.7027 70.0289 34.705Z",
    fill: "url(#paint5_linear_75_12028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M84.8984 34.58L76.4187 34.6317C76.0501 34.6339 75.7531 34.9346 75.7554 35.3032C75.7577 35.6718 76.0583 35.9688 76.427 35.9666L84.9067 35.9149C85.2753 35.9126 85.5723 35.612 85.57 35.2434C85.5677 34.8747 85.267 34.5777 84.8984 34.58Z",
    fill: "url(#paint6_linear_75_12028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M99.7261 34.4549L91.2463 34.5067C90.8777 34.5089 90.5807 34.8096 90.583 35.1782C90.5853 35.5468 90.886 35.8438 91.2546 35.8416L99.7344 35.7899C100.103 35.7876 100.4 35.4869 100.398 35.1183C100.395 34.7497 100.095 34.4527 99.7261 34.4549Z",
    fill: "url(#paint7_linear_75_12028)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 140",
    cx: 61,
    cy: 120.414,
    rx: 30,
    ry: 4,
    fill: "#400579"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 812433"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4433",
    x: 33,
    y: 57,
    width: 54,
    height: 54,
    rx: 16,
    fill: "url(#paint8_linear_75_12028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M63.468 83.9994C63.468 86.2082 61.6896 88.0073 59.5023 88.0073C57.315 88.0073 55.5367 86.2082 55.5367 83.9994C55.5367 81.7906 57.315 79.9915 59.5023 79.9915C61.6896 79.9915 63.468 81.7906 63.468 83.9994ZM75.707 90.3675L73.0632 94.997C72.4569 96.0604 71.1068 96.4256 70.0546 95.8146C68.8614 95.1181 67.439 95.1164 66.2493 95.8146C65.0596 96.5093 64.3475 97.7527 64.3475 99.1421C64.3475 100.369 63.3588 101.369 62.1444 101.369H56.8568C55.6424 101.369 54.6536 100.369 54.6536 99.1421C54.6536 97.7527 53.9433 96.5076 52.7519 95.8146C51.5622 95.1181 50.1398 95.1181 48.9483 95.8146C47.8961 96.4274 46.546 96.0604 45.9379 94.9988L43.2941 90.371C42.6878 89.3076 43.0491 87.9449 44.0996 87.3304C45.2928 86.6339 46.0031 85.3888 46.0031 84.0012C46.0031 82.6135 45.2928 81.3666 44.1014 80.6737C43.0509 80.0574 42.6896 78.6947 43.2941 77.6331L45.9379 73.0035C46.546 71.9418 47.8961 71.5767 48.9466 72.1859C50.1398 72.8824 51.5622 72.8841 52.7519 72.1859C53.9416 71.4912 54.6536 70.2478 54.6536 68.8584C54.6536 67.6311 55.6424 66.6318 56.8568 66.6318H62.1444C63.3588 66.6318 64.3475 67.6311 64.3475 68.8584C64.3475 70.2478 65.0578 71.493 66.2493 72.1859C67.439 72.8824 68.8614 72.8824 70.0528 72.1859C71.1051 71.5713 72.4534 71.9383 73.0632 73.0017L75.707 77.6295C76.3116 78.6911 75.9503 80.0538 74.9016 80.6684C73.7083 81.3648 72.998 82.61 72.998 83.9976C72.998 85.3852 73.7083 86.6321 74.8998 87.325C75.9503 87.9414 76.3116 89.3058 75.707 90.3675ZM66.1118 83.9994C66.1118 80.3175 63.1473 77.3195 59.5023 77.3195C55.8574 77.3195 52.8929 80.3175 52.8929 83.9994C52.8929 87.6813 55.8574 90.6792 59.5023 90.6792C63.1473 90.6792 66.1118 87.6813 66.1118 83.9994Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_12028",
    x1: 61,
    y1: 40.3721,
    x2: 61,
    y2: 122.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49028E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_12028",
    x1: 60.8009,
    y1: 13.2051,
    x2: 60.8009,
    y2: 27.8894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_12028",
    x1: 16.3629,
    y1: 35.6761,
    x2: 26.1775,
    y2: 35.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_12028",
    x1: 31.1903,
    y1: 35.6761,
    x2: 41.0049,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_12028",
    x1: 46.0597,
    y1: 35.6761,
    x2: 55.8743,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_12028",
    x1: 60.8877,
    y1: 35.7181,
    x2: 70.7023,
    y2: 35.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_12028",
    x1: 75.7572,
    y1: 35.5931,
    x2: 85.5718,
    y2: 35.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_12028",
    x1: 90.5848,
    y1: 35.4681,
    x2: 100.399,
    y2: 35.4071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_12028",
    x1: 60,
    y1: 57,
    x2: 60,
    y2: 113.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E600EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9002FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_12028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGameMaintain);
export default __webpack_public_path__ + "static/media/img_game_maintain.8a0f673bdc339a1fae0127aa818fe29e.svg";
export { ForwardRef as ReactComponent };